import Vue from 'vue';
import Vuex from 'vuex';

import parameters from './modules/parameters';
import projects from './modules/projects';
import projectTasks from './modules/projectTasks';
import regularTasks from './modules/regularTasks';
import regularTaskTypes from './modules/regularTaskTypes';
import resume from './modules/resume';
import alert from './modules/alert';
import app from './modules/app';
import projectStatusTypes from './modules/projectStatusTypes';
import projectSubTasks from './modules/projectSubTasks';
import workers from './modules/workers';
import parameterTypes from './modules/parameterTypes';

export const actions = {
  init({ dispatch }) {
    dispatch('parameters/init');
    dispatch('regularTasks/getList');
    dispatch('projectTasks/getAll');
    dispatch('projectStatusTypes/getList');
  },
};

Vue.use(Vuex);

const store = new Vuex.Store({
  actions,
  modules: {
    app,
    parameters,
    regularTasks,
    regularTaskTypes,
    projects,
    projectTasks,
    resume,
    alert,
    projectStatusTypes,
    workers,
    projectSubTasks,
    parameterTypes,
  },
});

window.store = store;

export default store;
